// types
import { DefaultConfigProps } from "types/config";

export const DMS_IDEAL: number = 1;
export const DMS_CSYSTEMS: number = 2;
export const DMS_CHARTER: number = 3;

export const DMS_IDEAL_STR: string = "Ideal";
export const DMS_CSYSTEMS_STR: string = "c-Systems";
export const DMS_CHARTER_STR: string = "Charter";

export const drawerWidth = 260;

// ==============================|| THEME CONFIG  ||============================== //

// --------------------------------------------------------
// Set default configuration properties here
// --------------------------------------------------------

const config: DefaultConfigProps = {
  defaultPath: "/subscriptions/pricelist/list",
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  miniDrawer: true, // closes the drawer with the menu items
  container: false, // determines if the content stays within pre-defined widths or if they expand to the container
  mode: "light",
  presetColor: "default",
  themeDirection: "ltr",
  dms: DMS_IDEAL_STR
};

export default config;
